<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-batch-upload`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M33.992 12a2 2 0 012 2v.009l-.134 30.213c0 .982-.891 1.778-1.991 1.778H5.983c-1.1 0-1.991-.796-1.991-1.778l.142-30.444c0-.982.892-1.778 1.992-1.778h27.866zM32 16H8v26h24V16zm-11.222 4.293l7.071 7.071a1 1 0 010 1.414l-1.414 1.414a1 1 0 01-1.414 0l-2.937-2.937v10.33a1 1 0 01-1 1h-2a1 1 0 01-1-1V27.229l-2.963 2.964a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.414l7.071-7.071a1 1 0 011.414 0zM42 4a2 2 0 012 2v25a1 1 0 01-1 1h-2a1 1 0 01-1-1V8H21a1 1 0 01-1-1V5a1 1 0 011-1h21z"/></svg>
</template>
<script>

export default {
  name: 'IconBatchUpload',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
